import React from 'react';

const Left: React.FC = () => (
   <svg className='fill-content-dark group-hover:fill-content-white' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.0303 5.46967C14.7374 5.17678 14.2626 5.17678 13.9697 5.46967L7.96967 11.4697C7.67678 11.7626 7.67678 12.2374 7.96967 12.5303L13.9697 18.5303C14.2626 18.8232 14.7374 18.8232 15.0303 18.5303C15.3232 18.2374 15.3232 17.7626 15.0303 17.4697L9.56066 12L15.0303 6.53033C15.3232 6.23744 15.3232 5.76256 15.0303 5.46967Z"/>
   </svg>
);

export default Left;